import React from 'react';
import WarehouseOpsPage from './WarehouseOpsPage';
export default function WarehouseReports() {
  return <WarehouseOpsPage mode="reports" title="Warehouse Reports" subtitle="Review stock, movements, and operational performance" />;
}
